(() => {
  if (window.posessoryRestockInitialized) return;
  window.posessoryRestockInitialized = true;
  let pending = false;
  const bound = new WeakSet();
  const apiReady = () => typeof window._RestockRocket?.openModal === 'function';
  function update() {
    pending = false;
    const widgets = document.querySelectorAll('[data-posessory-restock]');
    if (!widgets.length) return;
    document.body.classList.toggle('posessory-restock-ready', apiReady());
    widgets.forEach(widget => {
      const form = document.getElementById(widget.dataset.formId);
      const button = widget.querySelector('button');
      if (!form || !button) return;
      let data;
      try { data = JSON.parse(form.querySelector('[data-product-json]')?.textContent || '{}'); } catch { return; }
      const variantId = new URLSearchParams(window.location.search).get('variant') || form.querySelector('[name="id"]')?.value;
      const variant = data.variants?.find(v => String(v.id) === String(variantId));
      widget.hidden = !apiReady() || !variant || variant.available;
      if (!bound.has(button)) {
        bound.add(button);
        button.addEventListener('click', () => {
          const selectedId = new URLSearchParams(window.location.search).get('variant') || form.querySelector('[name="id"]')?.value;
          const selected = data.variants?.find(v => String(v.id) === String(selectedId));
          if (selected && !selected.available && apiReady()) {
            window._RestockRocket.openModal(data, Number(selectedId));
            schedule();
          }
        });
      }
    });
    const widget = widgets[0];
    const heading = document.getElementById('form-Header-Text');
    const description = document.getElementById('form-Description');
    const submit = document.getElementById('form-Button');
    if (heading && ['Notify me','Sign Up for Restock Alert'].includes(heading.textContent.trim()) && heading.textContent !== widget.dataset.heading) heading.textContent = widget.dataset.heading;
    if (description && description.textContent.startsWith('Get a notification as soon as this product') && description.textContent !== widget.dataset.description) description.textContent = widget.dataset.description;
    if (submit && submit.textContent.trim() === 'tell me when she’s back ♡') submit.textContent = widget.dataset.submit;
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  }
  function start() {
    update();
    const observer = new MutationObserver(schedule);
    observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','value']});
    document.addEventListener('change', schedule);
    document.addEventListener('shopify:section:load', schedule);
    let attempts = 0;
    const timer = setInterval(() => { update(); if (apiReady() || ++attempts >= 150) clearInterval(timer); },200);
    window.addEventListener('pagehide', () => { observer.disconnect(); clearInterval(timer); },{once:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();